var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"be-alert",class:`${_vm.themes[_vm.type]} text-${_vm.position}`},[_c('div',{staticClass:"be-alert__inner"},[(_vm.title)?_c('h5',{staticClass:"be-alert__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.description)?_c('p',{staticClass:"be-alert__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }